// extracted by mini-css-extract-plugin
module.exports = {"formHeader":"BeneficiaryPassword_formHeader__3NXbq","formSubtext":"BeneficiaryPassword_formSubtext__-uC1c","formInputs":"BeneficiaryPassword_formInputs__1yTD1"};